import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import api from '../../services/api';
import TrainingRequiredModal from './TrainingRequiredModal';

/**
 * Route Guard for Scenario Access
 * Redirects to training mode if user hasn't completed training
 */
const ScenarioAccessGuard = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [canAccess, setCanAccess] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [trainingProgress, setTrainingProgress] = useState(0);

  useEffect(() => {
    checkTrainingAccess();
  }, []);

  const checkTrainingAccess = async () => {
    try {
      // Get user info to check role
      const userResponse = await api.get('/api/auth/me');

      const user = userResponse.data.data.user;
      const role = user.role;
      setUserRole(role);

      // Check if user has bypass_training enabled
      if (user.bypassTraining === true) {
        setCanAccess(true);
        setLoading(false);
        return;
      }

      // Admin, Director, Supervisor always have access
      if (['admin', 'director', 'supervisor'].includes(role)) {
        setCanAccess(true);
        setLoading(false);
        return;
      }

      // Managers need to check training status
      if (role === 'manager') {
        const statusResponse = await api.get('/api/training/status');
        const status = statusResponse.data.status;

        console.log('Training status check:', status);

        // Calculate progress
        const completed = status?.modules_completed || 0;
        const total = status?.total_modules || 14;
        const progress = total > 0 ? Math.round((completed / total) * 100) : 0;
        setTrainingProgress(progress);

        setCanAccess(status?.scenarios_unlocked === true);
      }

      setLoading(false);
    } catch (error) {
      console.error('Error checking training access:', error);
      setCanAccess(false);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Проверка доступа...</p>
        </div>
      </div>
    );
  }

  if (!canAccess && userRole === 'manager') {
    return (
      <TrainingRequiredModal
        isOpen={true}
        onClose={() => window.location.href = '/training-mode'}
        progress={trainingProgress}
      />
    );
  }

  return children;
};

ScenarioAccessGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ScenarioAccessGuard;
